/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('des.qn', function (el) {
        var dialog = document.querySelector(el.dataset.dialog);
        var toggle = MoyaContainer.get('core.toggle').create(el, dialog, 'desQnFilter', {
            closeOthers: true,
        });
        MoyaContainer.set('des.qn', toggle);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
